import React, { FC, useState } from "react";
import { useQuery } from "../../../utils";
import { useHistory } from "react-router";
import AbnormalPriceProduct from "./AbnormalPriceProduct";
import CompareThuocsiPrice from "./CompareThuocsiPrice";


enum StatisticalInventoryTabs {
    abnormal = "abnormal",
    compareThuocsiPrice = "compareThuocsiPrice",
}


const StatisticalInventory: FC = () => {
    const query = useQuery();
    const tabId: string = query.get("statisticalTabId") || StatisticalInventoryTabs.abnormal;
    const [activeTab, setActiveTab] = useState<string>(tabId)
    const history = useHistory()

    const getActiveClass = (tab: StatisticalInventoryTabs) => {
        return activeTab === tab ? 'active' : '';
    }
    const getActiveTab = () => {
        switch (activeTab) {
            case StatisticalInventoryTabs.abnormal:
                return <AbnormalPriceProduct />
            case StatisticalInventoryTabs.compareThuocsiPrice:
                return <CompareThuocsiPrice />
            default:
                <div></div>
        }
    }

    const onSelectTab = (tab: StatisticalInventoryTabs) => {
        history.push(`/admin-dashboard?dashboardTabId=2&statisticalTabId=${tab}`)
        setActiveTab(tab)
    }
    return <div
        style={{ minWidth: "100%" }}
    >
        <div className="upload-flow" >
            <div className="d-flex flex-wrap align-items-center">
                <a href="/#" onClick={
                    (e) => {
                        e.preventDefault();
                        onSelectTab(StatisticalInventoryTabs.abnormal)
                    }
                    } className={"upload-tab-title mt-3 mr-3 " + getActiveClass(StatisticalInventoryTabs.abnormal)}>
                    Giá bất thường
                </a>
                <a href="/#" onClick={
                    (e) => {
                        e.preventDefault();
                        onSelectTab(StatisticalInventoryTabs.compareThuocsiPrice)
                    }
                    } className={"upload-tab-title mt-3 " + getActiveClass(StatisticalInventoryTabs.compareThuocsiPrice)}>
                    So giá với TS
                </a>
            </div>
            {
                getActiveTab()
            }
        </div>
    </div>
}

export default StatisticalInventory;